
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import SbRunnerFormVariables from '@/components/stead/workspaces/stepbuilder/sbRunnerFormVariables.vue';
import {eRunStatus} from '@/store/stead/runner.store';
import SimpleForm from '@/components/shared/dialogs/SimpleForm.vue';
import {TerminalVariable, WsStepDataMessage} from '@/models/terminal.model';
import RunReporting from "@/components/shared/RunReporting.vue";
import {Variable} from "@/models/variable.model";
import {allVariables} from "@/axios/repository/variable.axios";

@Component({
  components: {RunReporting, SimpleForm, SbRunnerFormVariables}
})
export default class SbRunner extends Vue {
  // Les props
  @Prop() private pos!: number

  // Les propriétés
  private varRule = [(v: string) => v.length > 0 || 'Value is required'];
  private isValid: boolean = false
  private showVariableDialog: boolean = false
  private sformVariable: TerminalVariable = {name: '', value: ''}
  private env: Variable[] = []

  // Les propriétés calculées
  private get runner() {
    return this.$store.state.runner
  }

  private get variables(): TerminalVariable[] {
    const variables: TerminalVariable[] =  this.runner.compiler.variables
    const env = this.env
    this.runner.compiler.variables = variables.map<TerminalVariable>(v => {
      const idx = env.findIndex(e => e.name === v.name)
      return idx < 0 ? v : {name: v.name, value: env[idx].value}
    })
    return this.runner.compiler.variables
  }

  private get initVarTodo(): boolean {
    return (this.runner.runStatus === eRunStatus.INITIALIZATION_TODO) || (this.runner.runStatus === eRunStatus.COMPIL_ERRORS)
  }

  private get stepReport(): WsStepDataMessage | null {
    return this.$store.getters['runner/stepRunReport'](this.pos)
  }

  private get compilErrors() {
    const ready = this.runner.compiler.readyToRun()
    return !ready ? this.runner.compiler.getErrors() : []
  }

  private get prjid(): string | null {
    const prj = this.$store.state.current.Project
    return prj ? prj._id : null
  }

  // Les hooks
  public mounted() {
    this.loadEnvVar()
  }

  // Les méthodes surveillées
  @Watch('prjid')
  private async loadEnvVar() {
    if (this.prjid) {
      this.env = await allVariables(this.prjid)
    }
  }

  // Les méthodes d'instance
  private onContinue() {
    this.$store.commit('runner/continue')
  }

  private onChangePos() {
    this.$store.commit('runner/setCursor', this.pos)
  }

  private onClickPencil(jvar: TerminalVariable) {
    this.showVariableDialog = true
    this.sformVariable = jvar
  }

  // Les méthodes statiques
}
